






import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "@/store/action-types";
import { loadLanguageAsync } from "@/translations";
import { Route } from "vue-router";

@Component({})
export default class Home extends Vue {
  get route(): Route {
    return this.$route;
  }

  getSelectedLanguageByBrowser(): string {
    const browserLanguage = navigator.language;
    return browserLanguage.includes("pt") ? "pt" : "en";
  }

  didBrowserLanguageRedirect = false;

  redirectToBrowserLanguage(route: Route): void {
    const selectedLanguage = this.getSelectedLanguageByBrowser();
    if (this.$i18n.locale !== selectedLanguage) {
      loadLanguageAsync(selectedLanguage);
    }
    if (!route.params.lang && route.name) {
      this.didBrowserLanguageRedirect = true;
      this.$router.push({
        name: route.name === "root" ? "home" : route.name,
        params: { lang: selectedLanguage }
      });
    }
  }

  syncUrlLanguage(): void {
    this.$router.replace({ name: "home", params: { lang: this.$i18n.locale } });
  }

  @Watch("route")
  languageRedirect(route: Route) {
    if (route.name === "home" && !route.params.lang) {
      this.$router.replace({ name: "root" });
    } else if (route.name === "root") {
      if (!this.didBrowserLanguageRedirect) {
        this.redirectToBrowserLanguage(route);
      } else this.syncUrlLanguage();
    }
  }

  created() {
    this.$store.dispatch(Action.FETCH_SOUNDS);
  }
}
